module.exports = __webpack_public_path__ + "static/Piotr-profile-7ad4bc6b2b1a316b99725b906204e6ea.png";